export default {
    ENV: 'production',
    server: 'https://miniapp.yaduo.com/atourlife',
    ssoServer: 'https://user-gateway.yaduo.com/api/sso',
    wechatUrl: 'https://wechat.yaduo.com',
    mobiletUrl: 'https://mobile.yaduo.com', // 测试地址
    wxToken: 'https://miniapp.yaduo.com/atourlife/miniapp/api/getCommonConfigByWeChat?paramName=ebf4d1&isCorp=false&activeId=0&activitySource=&deviceId=&inactiveId=',
    qiniuHost: 'https://east-qiniu.yaduo.com/',
    finderAppId: 10000003,
};
